import React, { FC, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import HeaderFont from '../../../Standings/HelperClass/HeaderFont'
import { TestID } from '../../../../utils/PropTypesDefinitions'

export type TopPerformerHeaderProps = {
    valueTitle: string
    personTitle: string
    paddingRight?: '31px'
    rankingTitle?: string
} & TestID

const TopPerformerHeader: FC<TopPerformerHeaderProps> = ({
    personTitle,
    valueTitle,
    rankingTitle,
    paddingRight,
    testID,
}) => (
    <Grid noExpand height={33} backgroundColor="pearl" paddingX={5} testID={testID}>
        <Grid
            horizontal
            borderBottom="1px"
            borderColor="pearl-2"
            centerVertical
            paddingRight={paddingRight}
        >
            {rankingTitle ? (
                <Grid minWidth={33} width={33} marginRight={3} noExpand>
                    <HeaderFont>{rankingTitle}</HeaderFont>
                </Grid>
            ) : null}
            <Grid minWidth={150} marginRight={3}>
                <HeaderFont>{personTitle}</HeaderFont>
            </Grid>
            <Grid noExpand minWidth={0}>
                <HeaderFont>{valueTitle}</HeaderFont>
            </Grid>
        </Grid>
    </Grid>
)

export default memo(TopPerformerHeader)
